import React, { useEffect } from 'react';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/bulkPurchase/summaryTabStyle';
import { BodyS, BodySBold, HeadingLBold, HeadingM } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import Success from 'assets/img/ic_msg_success.svg';
import Warning from 'assets/img/ic_msg_warning.svg';
import Button from 'components/CustomButtons/Button';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { loadQualtrics } from '../../../utils/qualtrics';

// @ts-ignore
const useStyles = makeStyles(styles);

const SummaryTab = ({
	numbersCount,
	requestNumber,
	onClick,
	orderIsSuccessful,
}: {
	numbersCount: number;
	requestNumber: string;
	onClick: () => void;
	orderIsSuccessful: boolean;
}) => {
	const classes = useStyles();
	useEffect(() => {
		setTimeout(() => {
			loadQualtrics({ activity_type: 'Purchase Device' });
		}, 2000);
	}, []);
	return (
		<ConditionalRender
			show={orderIsSuccessful}
			onTrue={() => (
				<Card className={classes.card}>
					<CardBody>
						<div className={classes.descriptionWrapper}>
							<img className={classes.img} src={Success} alt="Success" />

							<div className={classes.heading}>
								<HeadingLBold>
									{translate('purchase.bulk.devices.tab.payment.success.title')}
								</HeadingLBold>
							</div>
							<BodyS disableMargin inline>
								{translate('purchase.bulk.devices.tab.payment.success.decription1')}
							</BodyS>
							<BodySBold disableMargin inline>
								{translate(
									'purchase.bulk.devices.tab.payment.success.decription2',
									numbersCount,
									numbersCount
								)}
							</BodySBold>
							<div className={classes.success}>
								<HeadingM color="success">
									{translate('purchase.bulk.devices.tab.payment.success.subtitle', requestNumber)}
								</HeadingM>
							</div>
							<div className={classes.buttonsWrapper}>
								<Button color="primary-light" onClick={onClick}>
									{translate('okey')}
								</Button>
							</div>
						</div>
					</CardBody>
				</Card>
			)}
			onFalse={() => (
				<Card className={classes.card}>
					<CardBody>
						<div className={classes.descriptionWrapper}>
							<img className={classes.img} src={Warning} alt="Warning" />

							<div className={classes.heading}>
								<HeadingLBold>
									{translate('purchase.bulk.devices.tab.payment.failed.title')}
								</HeadingLBold>
							</div>
							<div className={classes.buttonsWrapper}>
								<Button color="primary-light" onClick={onClick}>
									{translate('okey')}
								</Button>
							</div>
						</div>
					</CardBody>
				</Card>
			)}
		/>
	);
};

export default SummaryTab;
